import apiFetch from '../apiFetch'

export default function (body, token) {
  return apiFetch({ endPoint: 'user/profile', method: 'PUT', body: body, token: token })
}
